import script from "./DrawSvg.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawSvg.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__